module.exports = __webpack_public_path__ + "static/img/fp.b457670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fp.png
// module id = +59w
// module chunks = 0